﻿
export function setupBibblio() {
    $('[data-ads-body-copy]  p:nth-child(4)').after('<style>.bib__name {color: #d38407;}</style><div id="bib--rcm-text-only-element"></div>');
}